import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    global: {
      showPhoneForm: false,
      survey:[],
      globalC:[],
      surveyIsActive:false,
      beginFlow:false,
      squareMetersCounter:0,
      locationCounter:0,
      employeesCounter:0,
      spinner:true,
      whatPop:false,
      qaNumber: [],
      progress:0,
      answers:{},
      answersCount:'',
      avarage:{},
      firm: {
        firmId:'',
        noform:'',
        userid: '',
        saelgerid:'',
        firmName: '',
        cvr: '',
        addr: '',
        isCustomer: 'NonCustomer',
        sqm:'0 - 1500 m2',
        employees:'0 - 10',
        location:'1 - 2',
        user: {
          name:'',
          permissionemail:false,
          permissionphone:false
        }
      }
    }
  },
  getters: {
    showPhoneForm: state => {
      return state.global.showPhoneForm;
    },
    progress: state => {
      return state.global.progress;
    },
    survey: state => {
      return state.global.survey;
    },
    globalC: state => {
      return state.global.globalC;
    },
    surveyIsActive: state => {
      return state.global.surveyIsActive;
    },
    spinner: state => {
      return state.global.spinner;
    },
    answers: state => {
      return state.global.answers;
    },
    answersCount: state => {
      return state.global.answersCount;
    },
    avarage: state => {
      return state.global.avarage;
    },
    firm: state => {
      return state.global.firm;
    },
    qaNumber: state => {
      return state.global.qaNumber;
    },
    beginFlow: state => {
      return state.global.beginFlow;
    },
    whatPop: state => {
      return state.global.whatPop;
    },
    squareMetersCounter: state => {
      return state.global.squareMetersCounter;
    },
    locationCounter: state => {
      return state.global.locationCounter;
    },
    employeesCounter: state => {
      return state.global.employeesCounter;
    }
  },
  mutations: {
    setAvarage: (state, payload) => {
      Vue.set(state.global.avarage, payload[0], payload[1])
    }
  },
  actions: {
    setBeginFlow ({commit, state}, payload) {
      state.global.beginFlow = true
    },
    setSurvey ({commit, state}, payload) {
      state.global.survey = payload
    },
    setGlobal ({commit, state}, payload) {
      state.global.globalC = payload
    },
    setProgress ({commit, state}, payload) {
      state.global.progress = payload
    },
    setFirm ({commit, state}, payload) {
      state.global.firm = payload
    },
    setSurveyActive ({commit, state}, payload) {
      state.global.surveyIsActive = payload
    },
    setSpinner ({commit, state}, payload) {
      state.global.spinner = payload
    },
    setPrev ({commit, state}, payload) {
      //console.log(payload[0], payload[1], payload[2], payload[3]);
      state.global.survey[payload[0]].cat[payload[1]].questions[payload[2]].prev = payload[3];
    },
    setAnswers ({commit, state}, payload) {
      for (var key in payload) {
        state.global.answers[key] = []
        for (var c in payload[key].cat) {
          state.global.answers[key].push({q:[]})
        }
      }
    },
    setQnumber ({commit, state}, payload) {
      let temp = {};
      let count = 0
      for (var skey in state.global.survey) {
        for (var ckey in state.global.survey[skey].cat) {
          for (var qkey in state.global.survey[skey].cat[ckey].questions) {
            temp[count] = skey;
            count ++
          }
        }
        state.global.qaNumber.push(count + 1)
        count = 0;
      }
    },
    setNewAnswer ({commit, state}, payload) {

      let s = payload[0]; //Survey
      let c = payload[1]; //Category
      let q = payload[2]; //Questions
      let picked = payload[3];
      let isRadio = payload[4];



      let test = [];
      for (var i = 0; i < picked.length; i++) {
        test.push( state.global.survey[s].cat[c].questions[q].answers[picked[i]].score );
      }

      state.global.answers[s][c].q[q] = { a: picked, q: q, score: test};


      let avarage = [];

      for (var key in state.global.answers[s]) {
        for (var nKey in state.global.answers[s][key].q) {
          for (var sKey in state.global.answers[s][key].q[nKey].score) {
            avarage.push( Number(state.global.answers[s][key].q[nKey].score[sKey]) )
          }
        }
      }
      console.log(avarage);
      state.global.answersCount = avarage.length;

      Vue.nextTick(function () {
        commit('setAvarage', [s, avarage.reduce((a, b) => a + b, 0)/avarage.length] );
      });

    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js